import {memo} from 'react';

import type {SVGProps} from 'react';

export const CloseIcon = memo(function CloseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M23.3332 38.7501C31.8476 38.7501 38.7498 31.8478 38.7498 23.3334C38.7498 14.819 31.8476 7.91675 23.3332 7.91675C14.8188 7.91675 7.9165 14.819 7.9165 23.3334C7.9165 31.8478 14.8188 38.7501 23.3332 38.7501Z"
          fill="var(--icon-fill-orange)"
        />
        <path
          d="M29.4998 32.3333C26.8332 34.3333 23.5832 35.5833 19.9998 35.5833C11.4165 35.5833 4.4165 28.5833 4.4165 19.9999C4.4165 17.8333 4.9165 15.6666 5.6665 13.8333"
          stroke="var(--icon-stroke-orange)"
          strokeWidth={2.5}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0835 8.00008C12.7502 5.83341 16.2502 4.41675 20.0002 4.41675C28.5835 4.41675 35.5835 11.4167 35.5835 20.0001C35.5835 21.9167 35.2502 23.7501 34.5835 25.5001"
          stroke="var(--icon-stroke-orange)"
          strokeWidth={2.5}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.9168 14.0833L14.0835 25.9166"
          stroke="var(--icon-stroke-orange)"
          strokeWidth={2.5}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.9168 25.9166L14.0835 14.0833"
          stroke="var(--icon-stroke-orange)"
          strokeWidth={2.5}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
});
